import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles, Cpu, Zap, AlertTriangle } from "lucide-react";
import { TigoLayoutDialog } from "./TigoLayoutDialog";

const n = (v, d = 1) => (v == null ? "—" : Number(v).toLocaleString("it-IT", { maximumFractionDigits: d }));

// Card nel dettaglio impianto (Torri Monitoring): sistemi Tigo collegati + apertura layout.
export function TigoSystemsCard({ plantId }) {
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    let vivo = true;
    api.get(`/tigo/plants/${encodeURIComponent(plantId)}/systems`)
      .then((r) => { if (vivo) setList(r.data?.systems || []); })
      .catch(() => { if (vivo) setList([]); });
    return () => { vivo = false; };
  }, [plantId]);

  if (!list || list.length === 0) return null;
  return (
    <div className="space-y-2 rounded-xl border border-[#3DA935]/30 p-3" data-testid="plant-tigo-systems">
      <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-[#3DA935]">
        <Sparkles className="h-3.5 w-3.5" />Ottimizzatori Tigo
        <span className="ml-1 rounded-full bg-[#3DA935]/20 px-2 py-0.5 text-[10px] font-bold text-[#3DA935]">Demo</span>
      </div>
      {list.map((s) => (
        <button key={s.id} type="button" onClick={() => setOpen(s)} data-testid={`plant-tigo-system-${s.id}`}
          className="flex w-full items-center gap-3 rounded-lg border border-neutral-800 px-3 py-2 text-left text-sm transition-colors hover:bg-white/5">
          <Cpu className="h-4 w-4 shrink-0 text-[#3DA935]" />
          <span className="flex min-w-0 flex-1 flex-col">
            <span className="truncate font-semibold text-white">{s.nome || s.id}</span>
            <span className="truncate text-xs text-neutral-400">{s.ottimizzatori} ottimizzatori · {s.model}</span>
          </span>
          {(s.allarme + s.offline) > 0 && <span className="flex items-center gap-1 text-xs text-red-400"><AlertTriangle className="h-3.5 w-3.5" />{s.allarme + s.offline}</span>}
          <span className="flex items-center gap-1 font-mono font-bold text-[#3DA935]"><Zap className="h-3.5 w-3.5" />{n(s.potenza_dc_kw, 1)} kW</span>
        </button>
      ))}
      {open && <TigoLayoutDialog title={`Tigo · ${open.nome || open.id}`} editable systemId={open.id} loader={() => api.get(`/tigo/systems/${open.id}/layout`).then((r) => r.data)} onClose={() => setOpen(null)} />}
    </div>
  );
}
